<p-toast>
  <ng-template let-message pTemplate="message">
    <span
      [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')"
      [ngClass]="{
        'pi-info-circle': message.severity === 'info' && !message.icon,
        'pi-exclamation-triangle': message.severity === 'warn' && !message.icon,
        'pi-times-circle': message.severity === 'error' && !message.icon,
        'pi-check': message.severity === 'success' && !message.icon,
      }"
    ></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary" *ngIf="message.summary">{{ message.summary }}</div>
      <div class="p-toast-detail" *ngIf="message.detail">{{ message.detail }}</div>
      <div class="p-toast-data" *ngIf="message.data?.length">
        <ul class="list-disc ml-4">
          <li *ngFor="let item of message.data">{{ item }}</li>
        </ul>
      </div>
    </div>
  </ng-template>
</p-toast>
